/**
 * @voltxampere/ui — Red LED 5mm (Sprint 51-1 polish, dedicated variant)
 *
 * Standard 5mm red LED — generic GaAlAs / GaP, V_F ≈ 1.9V at 20mA.
 * Most common hobby LED, used in status indicators, blinking lights,
 * Arduino blink demos.
 *
 * Engine zero-diff invariant honored — schemaType `led` (Sprint 23 B1
 * dedicated stamp, Is=1e-12, n=3 LED defaults).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { led } from "../led.js";
export const ledRed5mm = {
    id: "led-red-5mm",
    nameTr: "LED Kırmızı 5mm (genel)",
    nameEn: "LED Red 5mm (generic)",
    shortcut: "D",
    category: "active",
    viewBox: led.viewBox,
    terminals: led.terminals,
    defaultLabel: "D",
    defaultValue: "RED",
    schemaType: "led",
    defaultParams: {
        is: 1e-12,
        n: 3,
        vForward: 1.9,
        color: "red",
        package: "T-1¾ (5mm)",
        wavelengthNm: 625,
        luminousIntensityMcd: 100,
    },
    renderSVG: () => led.renderSVG(),
};
//# sourceMappingURL=led-red-5mm.js.map